import store from '..'

export default {
  getLoggedUser: (state) => {
    if (state.user) {
      return state.user
    }

    const raw = localStorage.getItem('vitale-user')

    if (!raw) {
      return null
    }

    try {
      let parsed = JSON.parse(raw)

      if (typeof parsed === 'string') {
        parsed = JSON.parse(parsed)
      }

      if (parsed != null) {
        store.commit('Auth/authSetUser', parsed)
      }

      return parsed
    } catch (err) {
      console.error('Failed to parse vitale-user from localStorage:', err, raw)
      return null
    }
  },

  getLoggedUserPermissions: (state) => {
    if (state.permissions) {
      return state.permissions
    }

    const raw = localStorage.getItem('vitale-permissions')

    if (!raw) {
      return null
    }

    try {
      let parsed = JSON.parse(raw)

      if (typeof parsed === 'string') {
        parsed = JSON.parse(parsed)
      }

      if (parsed != null) {
        store.commit('Auth/authSetPermissions', parsed)
      }

      return parsed
    } catch (err) {
      console.error(
        'Failed to parse vitale-permissions from localStorage:',
        err,
        raw
      )
      return null
    }
  }
}
